import React from "react";

const ModelVerify = ({
    show,
    title = "Are you sure?",
    message = "Do you really want to delete this record?",
    confirmText = "Yes",
    cancelText = "No",
    id,
    name,
    onConfirm,
    onCancel,
}) => {
    return (
        <div className="upload-modal">
            <div
                className={`modal fade ${show ? "show" : ""}`}
                style={{ display: show ? "block" : "none" }}
                tabIndex="-1"
                aria-hidden={!show}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center">
                            <h1 className="add-success mt-2">{title}</h1>

                            <p>{message}</p>

                            <div className="button-holder mt-3">
                                <button
                                    className="btn btn-yes me-2"
                                    onClick={() => onConfirm?.(id, name)}
                                >
                                    {confirmText}
                                </button>

                                <button
                                    className="btn btn-no"
                                    onClick={onCancel}
                                >
                                    {cancelText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {show && <div className="modal-backdrop fade show"></div>}
        </div>
    );
};

export default ModelVerify;